import * as types from '../actionType'

const initialState = []

const sellerData = (state = initialState, action) => {
    switch (action.type) {
        case types.SELLER_INFO:
            return action.payload
        default:
            return state
    }
}

export {sellerData};